import { Location } from '@angular/common';
import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, NavigationExtras } from '@angular/router';

import { filter, Subject, takeUntil } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationService implements OnDestroy {
    private _history: string[] = [];

    private readonly _destroy$ = new Subject<void>();

    constructor(private readonly _router: Router, private readonly _location: Location) {

        this._router.events
            .pipe(
                filter(e => e instanceof NavigationEnd),
                takeUntil(this._destroy$))
            .subscribe((event: NavigationEnd) => this._history.push(event.urlAfterRedirects));
    }

    public ngOnDestroy(): void {
        this._destroy$.next();
        this._destroy$.complete();
    }

    public backToOwnedRoute(fallbackRouteCommands: any[], extras?: NavigationExtras): void {
        this._history.pop();

        if (this._history.length > 0) {
            this._location.back();
        } else {
            this._router.navigate(fallbackRouteCommands, extras);
        }
    }
}
